export default "__VITE_ASSET__1adc723e__"